module.exports = __webpack_public_path__ + "img/ico_notificacoes.8661f79a.svg";